import React from "react";
import { useUTMParams } from "./utm";
import { Spacer } from "./spacer";
import { useMediaQuery } from "@/hooks";
import { useDisplayMerchantNameAndAddress } from "@/core/splitio";

interface CatalogPartnerInfoProps {
  partnerName?: string;
  locationAdress?: string;
}
export const CatalogPartnerInfo = ({
  partnerName,
  locationAdress,
}: CatalogPartnerInfoProps) => {
  return (
    <div>
      {partnerName && <span style={{ fontWeight: "bold" }}>{partnerName}</span>}
      {locationAdress && <span> - {locationAdress}</span>}
      <Spacer size={24} />
    </div>
  );
};

export const MindspaceCatalogPartnerInfo = ({
  partnerName,
  locationAdress,
}: CatalogPartnerInfoProps) => {
  const { utmCampaign } = useUTMParams();
  const displayMerchantNameAndAddress = useDisplayMerchantNameAndAddress();
  const mq = useMediaQuery();

  if (
    utmCampaign !== "g-book-now" ||
    !displayMerchantNameAndAddress ||
    (!partnerName && !locationAdress)
  ) {
    return null;
  }

  return (
    <div className={mq.device === "desktop" ? "mt-5" : "mt-1"}>
      {partnerName && (
        <span style={{ color: mq.device === "desktop" ? "white" : "black" }}>
          {partnerName}
        </span>
      )}
      {locationAdress && (
        <span style={{ color: mq.device === "desktop" ? "white" : "black" }}>
          , {locationAdress}
        </span>
      )}
      <Spacer size={24} />
    </div>
  );
};
